import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import Button from '../../UI/Buttons/Button/Button';
import ReactModalWrap from '../../UI/Modals/ReactModalWrap/ReactModalWrap';
import { generateQRStringFromOrder, formatNBSAmount } from '../../../utils/nbsQRGenerator';
import styles from './DriverQRButton.module.scss';

interface DriverQRButtonProps {
  order: any;
}

const DriverQRButton: React.FC<DriverQRButtonProps> = ({ order }) => {
  const [showQRModal, setShowQRModal] = useState(false);
  
  const { qrString, validation } = generateQRStringFromOrder(order);

  const handleShowQR = () => {
    if (validation.canGenerateQR) {
      setShowQRModal(true);
    }
  };

  const closeModal = () => {
    setShowQRModal(false);
  };

  // Don't render button if this isn't a delivery order at all
  if (!order.userDeliveryResponse) {
    return null;
  }

  return (
    <>
      <Button
        buttonType={validation.canGenerateQR ? "blue" : "blue"}
        disabled={!validation.canGenerateQR}
        onClick={handleShowQR}
        style={{ marginBottom: '10px' }}
        title={validation.canGenerateQR ? 'Prikaži QR kod za plaćanje' : validation.errors.join(', ')}
      >
        QR kod
      </Button>

      {showQRModal && (
        <ReactModalWrap isOpen={showQRModal} close={closeModal}>
          <div className={styles.qrModalContent}>
            {/* Header */}
            <div className={styles.qrModalHeader}>
              <h3>QR kod za plaćanje</h3>
            </div>

            {/* QR Code Display */}
            <div className={styles.qrModalBody}>
              {validation.canGenerateQR ? (
                <div className={styles.qrContainer}>
                  <div className={styles.orderInfo}>
                    <p><strong>Rezervacija #{order.id}</strong></p>
                    <p><strong>{formatNBSAmount(order.totalPrice)}</strong></p>
                  </div>

                  <div className={styles.qrCodeWrapper}>
                    <QRCode
                      value={qrString!}
                      size={280}
                      level="H"
                      style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}
                    />
                  </div>

                  <div className={styles.instructions}>
                    <p><strong>Pokažite ovaj kod korisniku</strong></p>
                    <p>Korisnik skenira QR kod svojom bankovnom aplikacijom</p>
                  </div>
                </div>
              ) : (
                <div className={styles.qrError}>
                  <h4>⚠️ QR kod nije dostupan</h4>
                  {validation.errors.map((error, index) => (
                    <p key={index}>• {error}</p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </ReactModalWrap>
      )}
    </>
  );
};

export default DriverQRButton; 